if (!customElements.get('cart-custom')) {
  customElements.define(
    'cart-custom',
    class CartCustom extends HTMLElement {
      constructor() {
        super();
        this.handleUpdate = this.updateOnPrice.bind(this);
      }

      connectedCallback() {
        window.addEventListener('speedcart:initialized', this.updateCart.bind(this));
      }

      disconnectedCallback() {
        window.removeEventListener('speedcart:initialized', this.updateCart.bind(this));
        this.observer?.disconnect();
      }

      updateCart() {
        if (!this.cartDestination) return;
        this.cartDestination.textContent = '';
        this.cartDestination.append(this.querySelector('template').content.firstElementChild.cloneNode(true));
        this.cartDestination.append(this.querySelector('template').content.lastElementChild.cloneNode(true));

        if (this.cartSubtotal) {
          this.observer = new MutationObserver(() => this.updateOnPrice());
          this.observer.observe(this.cartSubtotal, {
            characterData: true,
            childList: true,
            subtree: true
          });
        }

        this.updateOnPrice();
      }

      updateOnPrice() {
        const symbol = this.getAttribute('data-currency-symbol');
        const amount = +this.cartSubtotal?.textContent.replace(symbol, '').replace(',', '.') || 0;

        const shippingEl = this.cartDestination?.querySelector('.shipping_price');
        if (!shippingEl) return;
        shippingEl.setAttribute('data-free-shipping', amount > 40);
      }

      get cartDestination() {
        return document.querySelector('.sc_cart_v2_tax-note');
      }

      get cartSubtotal() {
        return document.querySelector('.sc_cart_v2_total-original + span');
      }
    }
  )
}